import { Reducer } from "redux";

import { PatientFromMbiResponse } from "../models/api/Patient";
import { PaientFromMbiDispatchTypes } from "../models/dispatchTypes/Patient";
import { PatientFromMbiActionDispatchTypes } from "../constants/Patient";

const initialState: PatientFromMbiResponse = {
  loading: false,
  response: {
    proceedWithIngest: null,
    patientDetails: [
      {
        patientId: 0,
        fullName: "",
        gender: "",
        dateOfBirth: "",
        patientMbi: "",
        ahcccsId: "",
        blobId: "",
        blobFileName: null,
      },
    ],
  },
  error: null,
};

const PatientFromMbiReducer: Reducer<
  PatientFromMbiResponse,
  PaientFromMbiDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case PatientFromMbiActionDispatchTypes.PATIENT_FROM_MBI_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case PatientFromMbiActionDispatchTypes.PATIENT_FROM_MBI_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case PatientFromMbiActionDispatchTypes.PATIENT_FROM_MBI_RESET: {
      return initialState;
    }
  }
  return state;
};

export default PatientFromMbiReducer;
